import { UseQueryResult, useQuery } from '@tanstack/react-query';

import { ApiKeyClient, ApiKeyModel } from '../../api/api';
import useApiClient from './useApiClient';

export default function useApiKeys(): UseQueryResult<ApiKeyModel[], Error> {
	const client = useApiClient(ApiKeyClient) as ApiKeyClient;
	return useQuery({
		queryKey: ['apiKeys'],
		queryFn: async () =>
			(
				await client.search({
					paging: {
						pageIndex: 0,
						pageSize: 1000,
						sortBy: 'Name',
						sortAscending: true,
					},
				})
			).items,
	});
}
